export const GET_ALL_PERMISSIONS_REQUEST = '[RolePermissions] Get All Permissions Request';
export const GET_ALL_PERMISSIONS_SUCCESS = '[RolePermissions] Get All Permissions Success';
export const GET_ALL_PERMISSIONS_FAILURE = '[RolePermissions] Get All Permissions Failure';

export const CREATE_ROLE_REQUEST = '[RolePermissions] Create Role Request';
export const CREATE_ROLE_SUCCESS = '[RolePermissions] Create Role Success';
export const CREATE_ROLE_FAILURE = '[RolePermissions] Create Role Failure';

export const DELETE_ROLE_REQUEST = '[RolePermissions] Delete Role Request';
export const DELETE_ROLE_SUCCESS = '[RolePermissions] Delete Role Success';
export const DELETE_ROLE_FAILURE = '[RolePermissions] Delete Role Failure';

export const GET_USERS_AND_ROLES_START = 'GET_USERS_AND_ROLES_START';
export const GET_USERS_AND_ROLES_SUCCESS = 'GET_USERS_AND_ROLES_SUCCESS';
export const GET_USERS_AND_ROLES_FAIL = 'GET_USERS_AND_ROLES_FAIL';

export const UPDATE_USER_ROLES_REQUEST = 'UPDATE_USER_ROLES_REQUEST';
export const UPDATE_USER_ROLES_SUCCESS = 'UPDATE_USER_ROLES_SUCCESS';
export const UPDATE_USER_ROLES_FAILURE = 'UPDATE_USER_ROLES_FAILURE';
